import React, { createContext } from 'react';
import { useAsyncResource } from 'use-async-resource';
import { Configurations } from '../models/configuration-models';
import { useGetAllConfigurations } from '../utils/configuration-hooks';

interface OptionsContextProps {
    allConfigurations: Configurations;
}

export const OptionsContext = createContext({} as OptionsContextProps);

export const OptionsProvider: React.FC = ({ children }) => {
    const [getAllConfigurations] = useAsyncResource(useGetAllConfigurations, []);
    const allConfigurations = getAllConfigurations();

    return <OptionsContext.Provider value={{ allConfigurations }}>{children}</OptionsContext.Provider>;
};
